// Module
var code = "<div slide-visible=\"!chartConfig.series.length\" class=\"full-size relative\">\n    <div class=\"full-center text-large\" ng-i18next=\"longitudinal.noGraphData\"></div>\n</div>\n<highchart slide-visible=\"chartConfig.series.length\" class=\"full-size\" config=\"chartConfig\"></highchart>\n";
// Exports
module.exports = code;